export class ProgramMarketingDetailModel<T> {
  private data: T;

  constructor(data?: T) {
    if (data) this.Data = data;
  }

  set Data(detail: T) {
    this.data = detail;
  }

  get Data() {
    return this.data;
  }
}
